import React, { Component } from 'react';
import { connect } from 'react-redux';
import logo from '../logo.svg';
import { setUserName, setUserRole, login, setConvoCode } from '../actions';

const mapStateToProps = (state) => {
    return ({
        authorizing: state.user.authorizing,
        convoCode: state.convo.meta.convoCode
    });    
}

class LoginUI extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userName: '',
            role: 'guest',
            convoCode: ''
        }
        
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleRoleChange = this.handleRoleChange.bind(this);
        this.handleConvoCodeChange = this.handleConvoCodeChange.bind(this);
    }

    handleConvoCodeChange(event) {
        this.setState({ convoCode: event.target.value }, () => {
            this.props.dispatch(setConvoCode(this.state.convoCode));
        });
    }

    handleNameChange(event) {
        this.setState({ userName: event.target.value }, () => {
            this.props.dispatch(setUserName(this.state.userName));
        });
    }

    handleRoleChange(event) {
        this.setState({ role: event.target.value }, () => {
            this.props.dispatch(setUserRole(this.state.role));
            this.props.dispatch(login(this.props.convoCode));
        });
    }

    render() {
        console.log("convoCode:", this.props.convoCode);
        return (
            <div className="App">
                <header className="App-header">
                    <img src={logo} className="App-logo" alt="logo" />
                    <h1 className="App-title">Welcome to Chatpool</h1>
                </header>
                <h2 className="App-intro">
                    Chatpool is a moderated space where you can have a civil debate.
                </h2>
                <input placeholder="Enter your first name" type="text" name="userName" value={this.state.userName} onChange={this.handleNameChange}/>
                <input placeholder="Enter your conversation code" type="text" name="convoCode" value={this.state.convoCode} onChange={this.handleConvoCodeChange}/>
                <button label="Enter chatpool as moderator" value="moderator" onClick={this.handleRoleChange}>Enter chatpool as moderator</button>
                <button label="Enter chatpool as guest" value="guest" onClick={this.handleRoleChange}>Enter chatpool as guest</button>
            </div>
        );
    }
}

export default connect(mapStateToProps)(LoginUI);


// WEBPACK FOOTER //
// ./src/components/LoginUI.js